import common from "../../common";

export default class GelButton {
    constructor(states) {
        this.signals = {
            down    : new P3.utils.MiniSignal(),
            up      : new P3.utils.MiniSignal(),
            over    : new P3.utils.MiniSignal(),
            out     : new P3.utils.MiniSignal(),
            click   : new P3.utils.MiniSignal(),
            animate : new P3.utils.MiniSignal()
        };

        this.animate = true;
        this.animateIcon = true;
        this.animateOverScale = 1.1;
        this.animateDownScale = 0.9;
        this.animateIconOverScale = 1.2;

        this.enabled = true;

        this.upSoundName = null;
        this.overSoundName = null;
        this.downSoundName = null;
        this.clickSoundName = null;
        this.voSoundName = null;

        this._states = states;

        this._currentNormalTexture = this._states.normal;
        this._currentOverTexture = this._states.over;
        this._currentDownTexture = this._states.down;
        this._currentIconTexture = this._states.icon;
        this._currentIconOverTexture = this._states.iconOver;
        this._currentIconDownTexture = this._states.iconDown;

        this._tweens = {};

        this._position = "";
        this._scale = 1;
        this._tabIndex = -1;
        this._ariaLabel = "";

        this._resizeFunction = null;
        this._resizeListener = null;

        const size = PIXI.utils.isMobile.any ? 64 : 70;
        const width = this._currentNormalTexture ? Math.max(size, this._currentNormalTexture.frame.width) : size;
        const height = this._currentNormalTexture ? Math.max(size, this._currentNormalTexture.frame.height) : size;

        this._htmlElement = $("<div/>");
        this._htmlElement.scale = 1;
        this._htmlElement.css({
            "position"  : "absolute",
            "width"     : width + "px",
            "height"    : height + "px",
            "padding"   : 0 + "px",
            "cursor"    : "pointer"
        });

        this._background = $("<button type='button'>");
        this._background.css({
            "position"          : "absolute",
            "background-color"  : "transparent",
            "border"            : "none",
            "outline"           : "none",
            "cursor"            : "inherit"
        });
        this._htmlElement.append(this._background);
        this.setTexture(this._currentNormalTexture);

        this._icon = $("<div/>");
        this._icon.scale = 1;
        this._icon.css({
            "position"          : "absolute",
            "background-color"  : "transparent",
            "pointer-events"    : "none"
        });
        this._htmlElement.append(this._icon);
        this.setIconTexture(this._currentIconTexture);

        this._text = $("<div/>");
        this._text.css({
            "position"          : "absolute",
            "width"             : "100%",
            "height"            : "100%",
            "text-align"        : "center",
            "pointer-events"    : "none"
        });
        this._htmlElement.append(this._text);

        if (!PIXI.utils.isMobile.any) {
            this._htmlElement.mousedown((event) => this.onMouseDown(event));
            this._htmlElement.mouseup((event) => this.onMouseUp(event));
            this._htmlElement.click((event) => this.onMouseClick(event));
            this._htmlElement.mouseover((event) => this.onMouseOver(event));
            this._htmlElement.mouseout((event) => this.onMouseOut(event));
        } else {
            this._htmlElement.on("touchstart", (event) => this.onMouseDown(event));
            this._htmlElement.on("touchend", (event) => this.onMouseUp(event));
        }

        this._htmlElement.focusin((event) => this.onFocusIn(event));
        this._htmlElement.focusout((event) => this.onFocusOut(event));

        const container = $("#" + P3.View.holder.id);
        container.append(this._htmlElement);
    }

    static create(normal, over, down, icon) {
        const states = new P3.ButtonStates(normal, over, down, icon);
        return new GelButton(states);
    }

    destroy() {
        this._htmlElement.remove();

        if (this._resizeListener)
        {
            common.view.signals.resize.detach(this._resizeListener, this);
            this._resizeListener = null;
        }

        /*
        if (this._resizeFunction) {
            $(window).off("resize", this._resizeFunction);
            this._resizeFunction = null;
        }
        */
    }

    onMouseDown(event) {
        this._states.down && this.setTexture(this._currentDownTexture);
        this._states.iconDown && this.setTexture(this._currentIconDownTexture);

        if (this.animate) {
            this.stopAnimations();
            this._tweens.down = this.animateDown();
        }
        event.preventDefault();
        this._background.css("outline", "none");

        this.enabled && this.signals.down.dispatch(this, event);
    }

    onMouseUp(event) {
        this.setTexture(this._currentNormalTexture);
        if (this._states.iconOver && !PIXI.utils.isMobile.any) this.setIconTexture(this._currentIconOverTexture);
        else if (this._states.icon) this.setIconTexture(this._currentIconTexture);

        if (this.animate && this._tweens.down) {
            this.stopAnimations();
            !PIXI.utils.isMobile.any ? (this._tweens.over = this.animateOver()) : (this._tweens.out = this.animateOut());
        }
        event.preventDefault();

        this.upSoundName && P3.audio.playSound(this.upSoundName);
        this.enabled && this.signals.up.dispatch(this, event);

        PIXI.utils.isMobile.any && this.onMouseClick(event);
    }

    onMouseOver(event) {
        this._states.over && (this.setTexture(this._currentOverTexture));
        this._states.iconOver && (this.setIconTexture(this._currentIconOverTexture));

        if (this.animate && !PIXI.utils.isMobile.any) {
            this.stopAnimations();
            this._tweens.over = this.animateOver();
        }
        if (this.animateIcon && !PIXI.utils.isMobile.any) {
            this._tweens.iconOver = this.animateIconOver();
        }

        this.overSoundName && P3.audio.playSound(this.overSoundName);
        this.voSoundName && P3.audio.playButtonVO(this.voSoundName);
        this.enabled && this.signals.over.dispatch(this, event);
    }

    onMouseOut(event) {
        this.setTexture(this._currentNormalTexture);
        this._states.icon && this.setIconTexture(this._currentIconTexture);

        this.stopAnimations();
        this._tweens.out = this.animateOut();
        this._tweens.iconOut = this.animateIconOut();

        this.upSoundName && P3.audio.playSound(this.upSoundName);
        this.enabled && this.signals.out.dispatch(this, event);
    }

    onMouseClick(event) {
        this.clickSoundName && P3.audio.playSound(this.clickSoundName);
        this.enabled && this.signals.click.dispatch(this, event);
    }

    onFocusIn(event) {
        this._background.css("outline", "2px solid #5E9ED6");
        this.onMouseOver(null);
    }

    onFocusOut(event) {
        this._background.css("outline", "none");
        this.onMouseOut(null);
    }

    animateOver() {
        if (typeof TweenMax !== "undefined") {
            return TweenMax.to(this._htmlElement, 0.6, {
                scaleX: this.animateOverScale,
                scaleY: this.animateOverScale,
                ease: Elastic.easeOut,
                easeParams: [1],
                onComplete: function() {
                    this.signals.animate.dispatch(this, "over");
                },
                onCompleteScope: this
            });
        } else {
            return new P3.utils.TWEEN.Tween(this._htmlElement)
                .to({scale: this.animateOverScale}, 600)
                .easing(P3.utils.TWEEN.Easing.Elastic.Out)
                .onUpdate(() => {
                    this._htmlElement.css("transform", "scale(" + this._htmlElement.scale * this._scale + ")");
                })
                .onComplete(() => {
                    this.signals.animate.dispatch(this, "over");
                })
                .start();
        }
    }

    animateOut() {
        if (typeof TweenMax !== "undefined") {
            return TweenMax.to(this._htmlElement, 0.3, {
                scaleX: 1,
                scaleY: 1,
                ease: Back.easeInOut,
                easeParams: [2],
                onComplete: function() {
                    this.signals.animate.dispatch(this, "out");
                },
                onCompleteScope: this
            });
        } else {
            return new P3.utils.TWEEN.Tween(this._htmlElement)
                .to({scale: 1}, 300)
                .easing(P3.utils.Easing.Back2.InOut)
                .onUpdate(() => {
                    this._htmlElement.css("transform", "scale(" + this._htmlElement.scale * this._scale + ")");
                })
                .onComplete(() => {
                    this.signals.animate.dispatch(this, "out");
                })
                .start();
        }
    }

    animateDown() {
        if (typeof TweenMax !== "undefined") {
            return TweenMax.to(this._htmlElement, 0.14, {
                scaleX: this.animateDownScale,
                scaleY: this.animateDownScale,
                ease: Back.easeOut,
                easeParams: [1],
                onComplete: function () {
                    this.signals.animate.dispatch(this, "down");
                },
                onCompleteScope: this
            });
        } else {
            return new P3.utils.TWEEN.Tween(this._htmlElement)
                .to({scale: this.animateDownScale}, 140)
                .easing(P3.utils.TWEEN.Easing.Back.Out)
                .onUpdate(() => {
                    this._htmlElement.css("transform", "scale(" + this._htmlElement.scale * this._scale + ")");
                })
                .onComplete(() => {
                    this.signals.animate.dispatch(this, "down");
                })
                .start();
        }
    }

    animateIconOver() {
        if (typeof TweenMax !== "undefined") {
            return TweenMax.to(this._icon, 0.8, {
                scaleX: this.animateIconOverScale,
                scaleY: this.animateIconOverScale,
                ease: Elastic.easeOut,
                easeParams: [1.6]
            });
        } else {
            return new P3.utils.TWEEN.Tween(this._icon)
                .to({scale: this.animateIconOverScale}, 800)
                .easing(function(k) {
                    if (k === 0) return 0;
                    if (k === 1) return 1;
                    return Math.pow(2, -10 * k) * Math.sin((k - 0.04) * 8 * Math.PI) + 1;
                })
                .onUpdate(() => {
                    this._icon.css("transform", "scale(" + this._icon.scale + ")");
                })
                .start();
        }
    }

    animateIconOut() {
        if (typeof TweenMax !== "undefined") {
            return TweenMax.to(this._icon, 0.34, {
                scaleX: 1,
                scaleY: 1,
                ease: Power1.easeInOut
            });
        } else {
            return new P3.utils.TWEEN.Tween(this._icon)
                .to({scale: 1}, 340)
                .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                .onUpdate(() => {
                    this._icon.css("transform", "scale(" + this._icon.scale + ")");
                })
                .start();
        }
    }

    stopAnimations() {
        if (typeof TweenMax !== "undefined") {
            for (const i in this._tweens) {
                if (this._tweens.hasOwnProperty(i)) {
                    const tween = this._tweens[i];
                    tween.kill();
                }
            }
            this._tweens = {};
        } else {
            for (const i in this._tweens) {
                if (this._tweens.hasOwnProperty(i)) {
                    const tween = this._tweens[i];
                    tween.stop();
                }
            }
            this._tweens = {};
        }
    }

    setTexture(texture) {
        const x         = texture.frame.x;
        const y         = texture.frame.y;
        const width     = texture.frame.width;
        const height    = texture.frame.height;
        const imageUrl  = texture.baseTexture.imageUrl;

        this._background.css({
            "left": (this._htmlElement.width() - width) * 0.5 + "px",
            "top": (this._htmlElement.height() - height) * 0.5 + "px",
            "width": width + "px",
            "height": height + "px",
            "background-image": "url(" + imageUrl + ")",
            "background-position": -x + "px " + -y + "px",
        });
    }

    setIconTexture(texture) {
        if (texture) {
            const x         = texture.frame.x;
            const y         = texture.frame.y;
            const width     = texture.frame.width;
            const height    = texture.frame.height;
            const imageUrl  = texture.baseTexture.imageUrl;

            this._icon.css({
                "left": (this._htmlElement.width() - width) * 0.5 + "px",
                "top": (this._htmlElement.height() - height) * 0.5 + "px",
                "width": width + "px",
                "height": height + "px",
                "background-image": "url(" + imageUrl + ")",
                "background-position": -x + "px " + -y + "px",
            });
        } else {
            this._icon.css("background-image", "none");
        }
    }

    setText(text = "", size = 20, color = "white") {
        this._text.html(text);
        this._text.css({
            "font-family": "BBC Reith Sans",
            "font-size": size + "px",
            "color": color
        });
        this._text.css({"line-height": this._htmlElement.height() + "px"});
    }

    setResizeFunction(func) {
        /*
        this._resizeFunction && $(window).off("resize", this._resizeFunction);
        this._resizeFunction = func;
        $(window).resize(() => {
            if (!common.view.isCorrectOrientation) return;
            func.call(this);
        });
        func && func.call();
         */

        this._resizeListener && common.view.signals.resize.detach(this._resizeFunction, this);

        if (this._resizeFunction)
        {
            this._resizeFunction = func;
            this._resizeListener = common.view.signals.resize.add(this._resizeFunction, this);
        }
        func && func.call();
    }

    resizeForDesktopWindowSize() {
        if (!PIXI.utils.isMobile.any) {
            if ($("#" + P3.View.holder.id).width() < 770) {
                this.scale = 0.656;
                return true;
            } else {
                this.scale = 1;
            }
        }
        return false;
    }

    getBottomPadding() {
        if ($("#" + P3.View.holder.id).width() <= 568) {
            return "32px";
        } else {
            return "4%";
        }
    }

    setStates(states) {
        this._states = states.clone();

        this.setTexture(this._states.normal);
        this.setIconTexture(this._states.icon);

        this._currentNormalTexture = this._states.normal;
        this._currentOverTexture = this._states.over;
        this._currentDownTexture = this._states.down;
        this._currentIconTexture = this._states.icon;
        this._currentIconOverTexture = this._states.iconOver;
        this._currentIconDownTexture = this._states.iconDown;
    }

    restoreTabIndex()
    {
        this._background.attr("tabIndex", this._tabIndex);
    }

    get states() {
        return this._states.clone();
    }

    get currentNormalTexture() {
        return this._currentNormalTexture;
    }

    get currentOverTexture() {
        return this._currentOverTexture;
    }

    get currentDownTexture() {
        return this._currentDownTexture;
    }

    get position() {
        return this._position;
    }

    set position(value) {
        const width = this._htmlElement.width();
        const height = this._htmlElement.height();

        this._position = value;
        switch (value) {
            default : {
                this._htmlElement.css({
                    "left"      : "auto",
                    "right"     : "auto",
                    "top"       : "auto",
                    "bottom"    : "auto",
                    "margin"    : "auto"
                });
                this.setResizeFunction(null);
                break;
            }
            case GelButton.POSITION_BOTTOM_LEFT : {
                this._htmlElement.css({
                    "left"          : "4%",
                    "right"         : "auto",
                    "top"           : "auto",
                    "bottom"        : "4%",
                    //"bottom"        : this.getBottomPadding(),
                    "margin"        : "auto",
                    "margin-left"   : 0 + "px",
                    "margin-top"    : 0 + "px"
                });
                this.setResizeFunction(() => {
                    if (this.resizeForDesktopWindowSize()) this._htmlElement.css("left", "-1%");
                    else this._htmlElement.css("left", "4%");
                });
                break;
            }
            case GelButton.POSITION_BOTTOM_RIGHT : {
                this._htmlElement.css({
                    "left"          : "auto",
                    "right"         : "4%",
                    "top"           : "auto",
                    "bottom"        : PIXI.utils.isMobile.any ? "3%" : "4%",
                    //"bottom"        : this.getBottomPadding(),
                    "margin"        : "auto",
                    "margin-left"   : 0 + "px",
                    "margin-top"    : 0 + "px"
                });
                this.setResizeFunction(() => {
                    if (this.resizeForDesktopWindowSize()) this._htmlElement.css("right", "-1%");
                    else this._htmlElement.css("right", "4%");
                });
                break;
            }
            case GelButton.POSITION_TOP_LEFT : {
                this._htmlElement.css({
                    "left"          : "2%",
                    "right"         : "auto",
                    "top"           : ($(window).height() * 0.02) + "px",
                    "bottom"        : "auto",
                    "margin"        : "auto",
                    "margin-left"   : 0 + "px",
                    "margin-top"    : 0 + "px"
                });
                this.setResizeFunction(() => this.resizeForDesktopWindowSize());
                break;
            }
            case GelButton.POSITION_TOP_RIGHT_FIRST : {
                this._htmlElement.css({
                    "left"          : "auto",
                    "right"         : "2%",
                    "top"           : ($(window).height() * 0.02) + "px",
                    "bottom"        : "auto",
                    "margin"        : "auto",
                    "margin-left"   : 0 + "px",
                    "margin-top"    : 0 + "px"
                });
                this.setResizeFunction(() => this.resizeForDesktopWindowSize());
                break;
            }
            case GelButton.POSITION_TOP_RIGHT_SECOND : {
                this._htmlElement.css({
                    "left"      : "auto",
                    "right"     : "2%",
                    "top"       : ($(window).height() * 0.02) + "px",
                    "bottom"    : "auto",
                    "margin"    : "auto"
                });
                this.setResizeFunction(() => {
                    const small = this.resizeForDesktopWindowSize();

                    let right = this._htmlElement.width();
                    if (!PIXI.utils.isMobile.any && !small) {
                        right += 24 - ((this._htmlElement.width() - this._background.width()));
                    }
                    this._htmlElement.css("right", "2%").css("right", "+=" + right + "px");
                });
                break;
            }
            case GelButton.POSITION_TOP_RIGHT_THIRD : {
                this._htmlElement.css({
                    "left"      : "auto",
                    "right"     : "2%",
                    "top"       : ($(window).height() * 0.02) + "px",
                    "bottom"    : "auto",
                    "margin"    : "auto"
                });
                this.setResizeFunction(() => {
                    const small = this.resizeForDesktopWindowSize();
                    let right = this._htmlElement.width() * 2;
                    if (!PIXI.utils.isMobile.any && !small) {
                        right += 24 - ((this._htmlElement.width() - this._background.width()));
                        right += 24 - ((this._htmlElement.width() - this._background.width()));
                    }
                    this._htmlElement.css("right", "2%").css("right", "+=" + right + "px");
                });
                break;
            }
            case GelButton.POSITION_TOP_RIGHT_FOURTH : {
                this._htmlElement.css({
                    "left"      : "auto",
                    "right"     : "2%",
                    "top"       : ($(window).height() * 0.02) + "px",
                    "bottom"    : "auto",
                    "margin"    : "auto"
                });
                this.setResizeFunction(() => {
                    const small = this.resizeForDesktopWindowSize();

                    let right = this._htmlElement.width() * 3;
                    if(!PIXI.utils.isMobile.any && !small) {
                        right += 24 - ((this._htmlElement.width() - this._htmlElement.button.width()));
                        right += 24 - ((this._htmlElement.width() - this._htmlElement.button.width()));
                        right += 24 - ((this._htmlElement.width() - this._htmlElement.button.width()));
                    }
                    this._htmlElement.css("right", "2%").css("right", "+=" + right + "px");
                });
                break;
            }
            case GelButton.POSITION_LEFT : {
                this._htmlElement.css({
                    "left"          : "2%",
                    "right"         : "auto",
                    "top"           : "50%",
                    "bottom"        : "auto",
                    "margin"        : "auto",
                    "margin-left"   : 0 + "px",
                    "margin-top"    : -height * 0.5 + "px"
                });
                this.setResizeFunction(() => this.resizeForDesktopWindowSize());
                break;
            }
            case GelButton.POSITION_RIGHT : {
                this._htmlElement.css({
                    "left"          : "auto",
                    "right"         : "2%",
                    "top"           : "50%",
                    "bottom"        : "auto",
                    "margin"        : "auto",
                    "margin-left"   : 0 + "px",
                    "margin-top"    : -height * 0.5 + "px"
                });
                this.setResizeFunction(() => this.resizeForDesktopWindowSize());
                break;
            }
            case GelButton.POSITION_MIDDLE : {
                this._htmlElement.css({
                    "left"          : "50%",
                    "right"         : "auto",
                    "top"           : "50%",
                    "bottom"        : "auto",
                    "margin"        : "auto",
                    "margin-left"   : -width * 0.5 + "px",
                    "margin-top"    : -height * 0.5 + "px"
                });
                this.setResizeFunction(() => this.resizeForDesktopWindowSize());
                break;
            }
            case GelButton.POSITION_MIDDLE_LOW : {
                this._htmlElement.css({
                    "left"          : "50%",
                    "right"         : "auto",
                    "top"           : "74%",
                    "bottom"        : "auto",
                    "margin"        : "auto",
                    "margin-left"   : -width * 0.5 + "px",
                    "margin-top"    : -height * 0.5 + "px"
                });
                this.setResizeFunction(() => this.resizeForDesktopWindowSize());
                break;
            }
            case GelButton.POSITION_MIDDLE_THREE_LEFT : {
                this._htmlElement.css({
                    "left"          : "50%",
                    "right"         : "right",
                    "top"           : "50%",
                    "bottom"        : "auto",
                    "margin"        : "auto",
                    "margin-left"   : -width * 0.5 + "px",
                    "margin-top"    : -height * 0.5 + "px"
                });
                this.setResizeFunction(() => {
                    if (P3.View.width < P3.View.height) return;     // Skip on portrait, quick fix for mobile issues
                    const small = this.resizeForDesktopWindowSize();

                    let left = !PIXI.utils.isMobile.any && !small ? 170 : 110;
                    this._htmlElement.css("left", "50%").css("left", "-=" + left + "px");
                });
                break;
            }
            case GelButton.POSITION_MIDDLE_THREE_RIGHT : {
                this._htmlElement.css({
                    "left"          : "50%",
                    "right"         : "auto",
                    "top"           : "50%",
                    "bottom"        : "auto",
                    "marin"         : "auto",
                    "margin-left"   : -width * 0.5 + "px",
                    "margin-top"    : -height * 0.5 + "px"
                });
                this.setResizeFunction(() => {
                    if (P3.View.width < P3.View.height) return;     // Skip on portrait, quick fix for mobile issues
                    const small = this.resizeForDesktopWindowSize();

                    let left = !PIXI.utils.isMobile.any && !small ? 170 : 110;
                    this._htmlElement.css("left", "50%").css("left", "+=" + left + "px");
                });
                break;
            }
            case GelButton.POSITION_MIDDLE_TWO_LEFT : {
                this._htmlElement.css({
                    "left"          : "50%",
                    "right"         : "auto",
                    "top"           : "50%",
                    "bottom"        : "auto",
                    "margin"        : "auto",
                    "margin-left"   : -width * 0.5 + "px",
                    "margin-top"    : -height * 0.5 + "px"
                });
                this.setResizeFunction(() => {
                    const small = this.resizeForDesktopWindowSize();

                    let left = !PIXI.utils.isMobile.any && !small ? 150 : 75;
                    this._htmlElement.css("left", "50%").css("left", "-=" + left + "px");
                });
                break;
            }
            case GelButton.POSITION_MIDDLE_TWO_RIGHT : {
                this._htmlElement.css({
                    "left"          : "50%",
                    "right"         : "auto",
                    "top"           : "50%",
                    "bottom"        : "auto",
                    "margin"        : "auto",
                    "margin-left"   : -width * 0.5 + "px",
                    "margin-top"    : -height * 0.5 + "px"
                });
                this.setResizeFunction(() => {
                    const small = this.resizeForDesktopWindowSize();

                    let left = !PIXI.utils.isMobile.any && !small ? 150 : 75;
                    this._htmlElement.css("left", "50%").css("left", "+=" + left + "px");
                });
                break;
            }
            case GelButton.POSITION_MIDDLE_LEVEL : {
                this._htmlElement.css({
                    "left"          : "50%",
                    "right"         : "auto",
                    "top"           : "45%",
                    "bottom"        : "auto",
                    "margin"        : "auto",
                    "margin-left"   : -width * 0.5 + "px",
                    "margin-top"    : -height * 0.5 + "px"
                });
                this.setResizeFunction(() => this.resizeForDesktopWindowSize());
                break;
            }
            case GelButton.POSITION_MIDDLE_LEVEL_DOWN : {
                this._htmlElement.css({
                    "left"          : "50%",
                    "right"         : "auto",
                    "top"           : "85%",
                    "bottom"        : "auto",
                    "margin"        : "margin",
                    "margin-left"   : -width * 0.5 + "px",
                    "margin-top"    : -height * 0.5 + "px"
                });
                this.setResizeFunction(() => this.resizeForDesktopWindowSize());
                break;
            }
            case GelButton.POSITION_MIDDLE_LEVEL_LEFT : {
                this._htmlElement.css({
                    "left"          : "auto",
                    "right"         : "auto",
                    "top"           : "60%",
                    "bottom"        : "auto",
                    "margin"        : "auto",
                    "margin-left"   : -width * 0.5 + "px",
                    "margin-top"    : -height * 0.5 + "px"
                });
                this.setResizeFunction(() => {
                    this.resizeForDesktopWindowSize();

                    const percent = 240 / P3.View.width;
                    const amount = $(window).width() * percent;
                    this._htmlElement.css("left", "50%").css("left", "-=" + amount + "px");
                });
                break;
            }
            case GelButton.POSITION_MIDDLE_LEVEL_RIGHT : {
                this._htmlElement.css({
                    "left"          : "auto",
                    "right"         : "auto",
                    "top"           : "60%",
                    "bottom"        : "auto",
                    "margin"        : "margin",
                    "margin-left"   : -width * 0.5 + "px",
                    "margin-top"    : -height * 0.5 + "px"
                });
                this.setResizeFunction(() => {
                    this.resizeForDesktopWindowSize();

                    const percent = 240 / P3.View.width;
                    const amount = $(window).width() * percent;
                    this._htmlElement.css("left", "50%").css("left", "+=" + amount + "px");
                });
                break;
            }
            case GelButton.POSITION_LOW_TWO_LEFT : {
                this._htmlElement.css({
                    "left"          : "50%",
                    "right"         : "auto",
                    "top"           : "auto",
                    "bottom"        : PIXI.utils.isMobile.any ? "15px" : "52px",
                    "margin"        : "auto",
                    "margin-left"   : -width * 0.5 + "px",
                    "margin-top"    : -height * 0.5 + "px"
                });
                this.setResizeFunction(() => {
                    const small = this.resizeForDesktopWindowSize();

                    let left = !PIXI.utils.isMobile.any && !small ? 140 : 110;
                    this._htmlElement.css("left", "50%").css("left", "-=" + left + "px");
                });
                break;
            }
            case GelButton.POSITION_LOW_TWO_CENTER : {
                this._htmlElement.css({
                    "left"          : "50%",
                    "right"         : "auto",
                    "top"           : PIXI.utils.isMobile.any ? "70%" : "66%",
                    "bottom"        : "auto",
                    "margin"        : "auto",
                    "margin-left"   : -width * 0.5 + "px",
                    "margin-top"    : -height * 0.5 + "px"
                });
                this.setResizeFunction(() => this.resizeForDesktopWindowSize());
                break;
            }
            case GelButton.POSITION_LOW_TWO_RIGHT : {
                this._htmlElement.css({
                    "left"          : "50%",
                    "right"         : "auto",
                    "top"           : "auto",
                    "bottom"        : PIXI.utils.isMobile.any ? "15px" : "52px",
                    "margin"        : "auto",
                    "margin-left"   : -width * 0.5 + "px",
                    "margin-top"    : -height * 0.5 + "px"
                });
                this.setResizeFunction(() => {
                    const small = this.resizeForDesktopWindowSize();

                    let left = !PIXI.utils.isMobile.any && !small ? 140 : 110;
                    this._htmlElement.css("left", "50%").css("left", "+=" + left + "px");
                });
                break;
            }
            case GelButton.POSITION_SETTINGS_CLOSE : {
                this._htmlElement.css({
                    "left"          : "auto",
                    "right"         : (PIXI.utils.isMobile.any ? 0 : 14) + "px",
                    "top"           : (PIXI.utils.isMobile.any ? 0 : 14) + "px",
                    "bottom"        : "auto",
                    "margin"        : "auto",
                    "margin-left"   : 0 + "px",
                    "margin-top"    : 0 + "px",
                });
                this.setResizeFunction(() => this.resizeForDesktopWindowSize());
                break;
            }
            case GelButton.POSITION_USER_SLOT_ONE : {
                this._htmlElement.css({
                    "left"          : "50%",
                    "right"         : "auto",
                    "top"           : "40%",
                    "bottom"        : "auto",
                    "margin"        : "auto",
                    "margin-left"   : -width * 0.5 + "px",
                    "margin-top"    : -height * 0.5 + "px"
                });
                this.setResizeFunction(() => this.resizeForDesktopWindowSize());
                break;
            }
            case GelButton.POSITION_USER_SLOT_TWO : {
                this._htmlElement.css({
                    "left"          : "50%",
                    "right"         : "auto",
                    "top"           : "54%",
                    "bottom"        : "auto",
                    "margin"        : "auto",
                    "margin-left"   : -width * 0.5 + "px",
                    "margin-top"    : -height * 0.5 + "px"
                });
                this.setResizeFunction(() => this.resizeForDesktopWindowSize());
                break;
            }
            case GelButton.POSITION_USER_SLOT_THREE : {
                this._htmlElement.css({
                    "left"          : "50%",
                    "right"         : "auto",
                    "top"           : "68%",
                    "bottom"        : "auto",
                    "margin"        : "auto",
                    "margin-left"   : -width * 0.5 + "px",
                    "margin-top"    : -height * 0.5 + "px"
                });
                this.setResizeFunction(() => this.resizeForDesktopWindowSize());
                break;
            }
            case GelButton.POSITION_PAUSE_PLAY : {
                this._htmlElement.css({
                    "left"          : "50%",
                    "right"         : "auto",
                    "top"           : "64%",
                    "bottom"        : "auto",
                    "margin"        : "auto",
                    "margin-left"   : -width * 0.5 + "px",
                    "margin-top"    : -height * 0.5 + "px"
                });
                this.setResizeFunction(() => this.resizeForDesktopWindowSize());
                break;
            }
            case GelButton.POSITION_PAUSE_RESTART : {
                this._htmlElement.css({
                    "left"          : "50%",
                    "right"         : "auto",
                    "top"           : "44%",
                    "bottom"        : "auto",
                    "margin"        : "auto",
                    "margin-left"   : -width * 0.5 + "px",
                    "margin-top"    : -height * 0.5 + "px"
                });
                this.setResizeFunction(() => this.resizeForDesktopWindowSize());
                break;
            }
        }
    }

    get htmlElement() {
        return this._htmlElement;
    }

    get tabIndex() {
        return this._tabIndex;
    }

    set tabIndex(value) {
        this._tabIndex = value;
        this._background.attr("tabIndex", value);
    }

    get ariaLabel() {
        return this._ariaLabel;
    }

    set ariaLabel(value) {
        this._ariaLabel = value;
        this._htmlElement.attr("aria-label", value);
        this._htmlElement.attr("role", "button");
    }

    get visible() {
        return this._htmlElement.is(":visible");
    }

    set visible(value) {
        if (value) this._htmlElement.show();
        else this._htmlElement.hide();
    }

    get scale() {
        return this._scale;
    }

    set scale(value) {
        this._scale = value;
        this._htmlElement.css({
            "transform"         : "scale(" + value * this._htmlElement.scale + ")",
            "-webkit-transform" : "scale(" + value * this._htmlElement.scale + ")",
            "-moz-transform"    : "scale(" + value * this._htmlElement.scale + ")",
            "-o-transform"      : "scale(" + value * this._htmlElement.scale + ")"
        });
    }
}

GelButton.POSITION_TOP_RIGHT_FIRST      = "position_top_right_first";
GelButton.POSITION_TOP_RIGHT_SECOND     = "position_top_right_second";
GelButton.POSITION_TOP_RIGHT_THIRD      = "position_top_right_third";
GelButton.POSITION_TOP_RIGHT_FOURTH     = "position_top_right_forth";
GelButton.POSITION_TOP_LEFT             = "position_top_left";
GelButton.POSITION_BOTTOM_RIGHT         = "position_bottom_right";
GelButton.POSITION_BOTTOM_LEFT          = "position_bottom_left";
GelButton.POSITION_LEFT                 = "position_left";
GelButton.POSITION_RIGHT                = "position_right";
GelButton.POSITION_MIDDLE               = "position_middle";
GelButton.POSITION_MIDDLE_LOW           = "position_middle_low";
GelButton.POSITION_MIDDLE_THREE_LEFT    = "position_middle_three_left";
GelButton.POSITION_MIDDLE_THREE_RIGHT   = "position_middle_three_right";
GelButton.POSITION_MIDDLE_TWO_LEFT      = "position_middle_two_left";
GelButton.POSITION_MIDDLE_TWO_RIGHT     = "position_middle_two_right";
GelButton.POSITION_MIDDLE_LEVEL         = "position_middle_level";
GelButton.POSITION_MIDDLE_LEVEL_LEFT    = "position_middle_level_left";
GelButton.POSITION_MIDDLE_LEVEL_RIGHT   = "position_middle_level_right";
GelButton.POSITION_MIDDLE_LEVEL_DOWN    = "position_middle_level_down";
GelButton.POSITION_LOW_TWO_LEFT         = "position_low_two_left";
GelButton.POSITION_LOW_TWO_RIGHT        = "position_low_two_right";
GelButton.POSITION_LOW_TWO_CENTER       = "position_low_two_center";
GelButton.POSITION_SETTINGS_CLOSE       = "position_settings_close";
GelButton.POSITION_USER_SLOT_ONE        = "position_user_slot_one";
GelButton.POSITION_USER_SLOT_TWO        = "position_user_slot_two";
GelButton.POSITION_USER_SLOT_THREE      = "position_user_slot_three";
GelButton.POSITION_PAUSE_RESTART        = "position_pause_restart";
GelButton.POSITION_PAUSE_PLAY           = "position_pause_play";

GelButton.TAB_INDEX_NONE    = -1;
GelButton.TAB_INDEX_LEVEL_0 = 1;
GelButton.TAB_INDEX_LEVEL_1 = 21;
GelButton.TAB_INDEX_LEVEL_2 = 41;
GelButton.TAB_INDEX_LEVEL_3 = 61;